import templatesPendingReview from './templatesPendingReviewSlice'
export default templatesPendingReview.reducer
